"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = exports.getCurrencySymbol = void 0;

var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));

/* External Libraries */
var getCurrencySymbol = function getCurrencySymbol(_currencyCode) {
  var currencyCode = (_currencyCode || "USD").toUpperCase();

  var symbol = (0, _currencySymbolMap["default"])(currencyCode);
  var prependCurrencyCode = symbol == "$" && currencyCode != "USD" || symbol == "£" && currencyCode != "GBP";
  return (prependCurrencyCode ? currencyCode.substring(0, 2) : "") + symbol;
}; // Third argument holds options to prevent additinoal expansion
// of parameters.
// eslint-disable-next-line local-rules/no-large-method-params


exports.getCurrencySymbol = getCurrencySymbol;

var formatCurrency = function formatCurrency(amount) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "USD";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    locale: "en-US"
  };
  var roundedAmount = typeof amount == "number" ? Number(amount.toFixed(2)) : amount;
  var locale = options.locale;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode
  }).format(roundedAmount);
};

exports.formatCurrency = formatCurrency;